import {
  Grid,
  TextField,
  Button,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useRef, useState } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CardHeader from "../General/CardHeader";
import GlassCard from "../General/GlassCard";

import { uploadMultiplesAttachmentsAportes } from "../../services/LegalFileService";
import { useToast } from "../../context/ToastContext";

export default function AportesAttachmentsManager() {
  const { showToast } = useToast();
  const filePdfRef = useRef(null);
  const fileZipRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const [fileType, setFileType] = useState("");
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [selectedZip, setSelectedZip] = useState(null);

  const handleFileTypeChange = (e) => {
    setFileType(e.target.value);
    setSelectedPdf(null);
    setSelectedZip(null);    if (filePdfRef.current) filePdfRef.current.value = "";
    if (fileZipRef.current) fileZipRef.current.value = "";
  };

  const handlePdfChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.name.split(".").pop().toLowerCase() !== "pdf") {
      showToast("El archivo debe ser .pdf", "info")
      if (filePdfRef.current) filePdfRef.current.value = "";
      setSelectedPdf(null);
      return;
    }
    setSelectedPdf(file);
  };

  const handleZipChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.name.split(".").pop().toLowerCase() !== "zip") {
      showToast("El archivo debe ser .zip", "info")
      if (fileZipRef.current) fileZipRef.current.value = "";
      setSelectedZip(null);
      return;
    }
    setSelectedZip(file);
  };

  const canSubmit =
    !loading &&
    fileType &&
    (fileType === "pdf" ? !!selectedPdf : !!selectedZip);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fileType) {
      showToast("Debe seleccionar el tipo de archivo.", "info")
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file_type", fileType);

      if (fileType === "pdf") {
        if (!selectedPdf) throw new Error("Debe seleccionar un PDF.");
        formData.append("pdf", selectedPdf);
      } else {
        if (!selectedZip) throw new Error("Debe seleccionar un ZIP.");
        formData.append("zip", selectedZip);
      }

      const res = await uploadMultiplesAttachmentsAportes(formData);

      showToast(
        `${res.data?.message || "Proceso ok"}. Expedientes vinculados: ${res.data?.totalLegalFile ?? 0}. PDFs procesados: ${res.data?.pdf_procesados ?? 0}.`,
      "success")

      setFileType("");
      setSelectedPdf(null);
      setSelectedZip(null);
      if (filePdfRef.current) filePdfRef.current.value = "";
      if (fileZipRef.current) fileZipRef.current.value = "";
    } catch (error) {
      console.error(error);
      showToast(
        error.response?.data?.message || error.message || "Error inesperado.",
      "error")
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10 }}>

        <GlassCard>
          <CardHeader
            icon={<AssignmentIcon />}
            title="Planilla de Aportes"
            description="Cargá un PDF o ZIP con planillas de aportes para vincularlos a los expedientes correspondientes."
          />

          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <FormControl fullWidth>
                  <InputLabel>Tipo de archivo</InputLabel>
                  <Select
                    value={fileType}
                    onChange={handleFileTypeChange}
                    label="Tipo de archivo"
                  >
                    <MenuItem value="">SELECCIONAR UNA OPCION...</MenuItem>
                    <MenuItem value="pdf">PDF</MenuItem>
                    <MenuItem value="zip">ZIP</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {fileType === "pdf" && (
                <>
                  <Grid size={{ xs: 12 }}>
                    <Button variant="outlined" component="label" fullWidth>
                      Seleccionar PDF
                      <input
                        type="file"
                        hidden
                        onChange={handlePdfChange}
                        ref={filePdfRef}
                      />
                    </Button>
                  </Grid>
                  {selectedPdf && (
                    <Grid size={{ xs: 12 }}>
                      <TextField
                        label="Archivo seleccionado"
                        value={selectedPdf.name}
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </Grid>
                  )}
                </>
              )}

              {fileType === "zip" && (
                <>
                  <Grid size={{ xs: 12 }}>
                    <Button variant="outlined" component="label" fullWidth>
                      Seleccionar ZIP
                      <input
                        type="file"
                        hidden
                        onChange={handleZipChange}
                        ref={fileZipRef}
                      />
                    </Button>
                  </Grid>
                  {selectedZip && (
                    <Grid size={{ xs: 12 }}>
                      <TextField
                        label="Archivo seleccionado"
                        value={selectedZip.name}
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </Grid>
                  )}
                </>
              )}

              <Grid size={{ xs: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                  disabled={!canSubmit}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Cargar planilla"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </GlassCard>
      </Grid>
    </Grid>
  );
}
